<template>
  <section>
    <b-row>
      <b-col md="12">
        <b-link :to="{ name: 'dinamicas' }">Regresar</b-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <h2>Grupos {{ encuesta.nombre }} <span v-if="$auth.can('agregar_grupos')">
            <b-button size="sm" variant="info" @click.prevent="agregar"><b-icon icon="plus-square"></b-icon> Agregar</b-button>
          </span></h2>
      </b-col>
    </b-row>
    <b-form ref="filtros" @submit.prevent="cargarGrupos">
      <b-form-row>
        <b-col sm="6">
          <b-form-group label="Nombre:" label-for="input-filtro-nombre">
            <b-form-input id="input-filtro-nombre" type="text" v-model="filtros.nombre"></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-button variant="primary" type="submit">Filtrar</b-button>
        </b-col>
      </b-form-row>
    </b-form>
    <b-row>
      <b-col md="12">
        <b-table responsive striped hover :items="grupos" :fields="campos">
          <template #cell(acciones)="row">
            <b-link href="" @click.prevent="editar(row.item)" v-if="$auth.can('editar_dinamicas')">Editar</b-link>
            <b-link href="" @click.prevent="eliminar(row.item)" v-if="$auth.can('eliminar_dinamicas')">Eliminar</b-link>
          </template>
        </b-table>
        <b-pagination v-model="page" :total-rows="count" :per-page="limit" aria-controls="my-table" align="center"></b-pagination>
      </b-col>
    </b-row>
    <b-modal v-model="mainModal" size="lg" no-close-on-backdrop>
      <b-form ref="mainForm" @submit.prevent="guardar">
        <b-form-group label="Identificador del grupo:" label-for="input-identificador" :invalid-feedback="errores.identificador">
          <b-form-input id="input-identificador" v-model="grupo.identificador" :state="$empty(errores.identificador)" trim></b-form-input>
          <b-form-text>Se refiere al nombre corto para identificar el grupo en la bd. (Ej. datosPersonales), no admite espacios, caracteres especiales ni tildes.</b-form-text>
        </b-form-group>
        <b-form-group label="Nombre del grupo:" label-for="input-nombre" :invalid-feedback="errores.nombre">
          <b-form-input id="input-nombre" v-model="grupo.nombre" :state="$empty(errores.nombre)" trim></b-form-input>
        </b-form-group>
        <b-form-group label="Orden:" label-for="input-orden" :invalid-feedback="errores.orden">
          <b-form-input id="input-orden" type="number" min="0" v-model="grupo.orden" :state="$empty(errores.orden)" trim></b-form-input>
          <b-form-text>Orden del grupo en la encuesta (de menor a mayor)</b-form-text>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="submit()">
          OK
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
  </section>
</template>

<script lang="ts">
import axios from 'axios'
import {Vue, Component, Watch} from 'vue-property-decorator'

import {url} from '../../../services/url_service'

@Component
export default class Grupos extends Vue {
  public page: number = 1
  public limit: number = 20
  public count: number = 0
  public mainModal: boolean = false
  public errores: any = {}
  public id?: number = null
  public grupo: any = {}
  public filtros: any = {}
  public grupos: any = []
  public encuestaId?: number = null
  public encuesta: any = {}
  public campos: any = [
    {
      key: 'nombre',
    },
    {
      key: 'orden',
    },
    {
      key: 'acciones',
    },
  ]
  public async cargarEncuesta() {
    try {
      let response = await axios.get(
        url.create(`/internal/dinamicas/${this.encuestaId}`)
      )
      this.encuesta = response.data
    } catch (ex) {
      this.$router.replace({name: 'dinamicas'})
    }
  }
  public async cargarGrupos() {
    let response = await axios.get(
      url.create(`/internal/dinamicas/${this.encuestaId}/grupos`),
      {
        params: {
          filtros: this.filtros,
          limit: this.limit,
          page: this.page,
        },
      }
    )
    this.grupos = response.data.data
    this.count = response.data.count
  }
  public async agregar() {
    this.errores = {}
    this.mainModal = true
    this.id = null
    this.grupo = {}
  }
  public async editar(grupo) {
    this.errores = {}
    this.mainModal = true
    this.id = grupo.id
    this.grupo = {
      identificador: grupo.identificador,
      nombre: grupo.nombre,
      orden: grupo.orden,
    }
  }
  public submit() {
    (this.$refs.mainForm as Element).dispatchEvent(new window.Event('submit'))
  }
  public async guardar() {
    try {
      this.errores = {}
      let promise = this.id
        ? axios.put(
            url.create(
              `/internal/dinamicas/${this.encuestaId}/grupos/${this.id}`
            ),
            this.grupo
          )
        : axios.post(
            url.create(`/internal/dinamicas/${this.encuestaId}/grupos`),
            this.grupo
          )
      let response = await promise
      this.mainModal = false
      this.cargarGrupos()
    } catch (ex) {
      this.errores = ex.response.data
    }
  }

  public async eliminar(pregunta) {
    try {
      if (await this.$bvModal.msgBoxConfirm('¿Está seguro de que desea eliminar este grupo?')) {
        await axios.delete(
          url.create(
            `/internal/dinamicas/${this.encuestaId}/grupos/${pregunta.id}`
          )
        )
        await this.cargarGrupos()
      }
    } catch (ex) {

    }
  }

  @Watch('page')
  public pageChange(value) {
    this.cargarGrupos()
  }
  created() {
    this.encuestaId = parseInt(this.$route.params['id'])
    this.cargarEncuesta()
    this.cargarGrupos()
  }
}
</script>

<style lang="scss">
</style>